import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExclamationCircleIcon } from '@heroicons/react/solid';
import PropTypes from 'prop-types';
import { mergeClassNames } from '../../../utils';
const FormLabel = ({ label, errors, htmlFor, required, errorClassName, successClassName, labelClassName, isSuccess, }) => {
    const labelClasses = mergeClassNames(labelClassName, 'flex text-sm font-medium text-gray-700');
    const successClasses = mergeClassNames(successClassName, 'flex text-sm font-medium text-green-700');
    const errorClasses = mergeClassNames(errorClassName, 'flex mt-2 text-sm font-medium text-red-600');
    return (_jsx(_Fragment, { children: (label.length > 0 || errors.length > 0) &&
            (errors[0]?.length > 0 ? (_jsxs("div", { className: errorClasses, children: [_jsx("span", { children: _jsx(ExclamationCircleIcon, { className: "w-5 h-5 text-red-500", "aria-hidden": "true" }) }), _jsx("label", { htmlFor: htmlFor, children: errors[0] })] })) : (_jsx("div", { className: isSuccess ? successClasses : labelClasses, children: _jsxs("label", { htmlFor: htmlFor, className: "flex flex-inline gap-1", children: [_jsx("div", { children: label }), required ? _jsx("div", { className: " text-red-500", children: "*" }) : null] }) }))) }));
};
FormLabel.propTypes = {
    label: PropTypes.string,
    errors: PropTypes.array,
    htmlFor: PropTypes.string,
    required: PropTypes.bool,
    errorClassName: PropTypes.string,
    labelClassName: PropTypes.string,
};
FormLabel.defaultProps = {
    label: '',
    errors: [],
    htmlFor: '',
    required: false,
    errorClassName: '',
    labelClassName: '',
};
export default FormLabel;
